import ContainedIcon from '@/components/ContainedIcon';
import MetaIconBase from '@/components/Icons/MetaIcon';

function MetaIcon() {
  return (
    <ContainedIcon size={24} color="#0081FB" borderRadius={6}>
      <MetaIconBase
        sx={{
          width: 16,
          height: 16,
          color: 'white',
        }}
      />
    </ContainedIcon>
  );
}

export default MetaIcon;
